import { API_URL } from '../../../app-config/constants';
import ObjectiveView from '../../../types/ObjectiveView';
import { get, post, put, remove } from '../request';

createObjective.operation = 'CREATE';
createObjective.invalidates = ['getForFeedback'];
export function createObjective(objective: any) {
    return post<ObjectiveView>(`${API_URL}/objective-cycles/${objective.cycleId}/objectives`, { postData: objective });
}

getObjective.operation = 'READ';
export function getObjective(cycleId: string, objectiveId: string) {
    return get<ObjectiveView>(`${API_URL}/objective-cycles/${cycleId}/objectives/${objectiveId}`);
}

getObjectiveChildren.operation = 'READ';
export function getObjectiveChildren(cycleId: string, parentId: string) {
    return get<ObjectiveView[]>(`${API_URL}/objective-cycles/${cycleId}/children/${parentId}`);
}

updateObjective.operation = 'COMMAND';
export function updateObjective(objective: any) {
    return put<ObjectiveView>(`${API_URL}/objective-cycles/${objective.cycleId}/objectives/${objective.id}`, {
        postData: objective,
    });
}

changeStatus.operation = 'COMMAND';
export function changeStatus(objective: any, queryParams: any) {
    return post<ObjectiveView>(
        `${API_URL}/objective-cycles/${objective.cycleId}/objectives/${objective.id}/changeStatus`,
        {
            getData: queryParams,
        }
    );
}

changeRating.operation = 'COMMAND';
export function changeRating(objective: any, queryParams: any) {
    return post<ObjectiveView>(
        `${API_URL}/objective-cycles/${objective.cycleId}/objectives/${objective.id}/changeRating`,
        {
            getData: queryParams,
        }
    );
}

changeCompletionPercentage.operation = 'COMMAND';
export function changeCompletionPercentage(objective: any, queryParams: any) {
    return post<ObjectiveView>(
        `${API_URL}/objective-cycles/${objective.cycleId}/objectives/${objective.id}/changeCompletionPercentage`,
        { getData: queryParams }
    );
}

deleteObjective.operation = 'DELETE';
export function deleteObjective(objectiveId: string, cycleId: string) {
    return remove(`${API_URL}/objective-cycles/${cycleId}/objectives/${objectiveId}`);
}

getAllObjectivesForUser.operation = 'READ';
// MISSING: updateOnCreate
export function getAllObjectivesForUser(userId: string) {
    return get<ObjectiveView[]>(`${API_URL}/objective-cycles/all/objectives/view`, { getData: { userId: userId } });
}

getForFeedback.operation = 'READ';
export function getForFeedback(feedbackRequestId: string) {
    return get<ObjectiveView[]>(`${API_URL}/objective-source/${feedbackRequestId}`);
}
